import Axios from 'axios'

const ENDPOINT = 'preregistry'

function toBase64(str) {
    return Buffer.from(str).toString('base64')
}

/**
 * Get
 * This endpoint does not require authentication
 * @param {*} email
 */
export const getObj = (email) => {
    return new Promise((resolve, reject) => {
        Axios.get(`/${ENDPOINT}/${toBase64(email)}`)
            .then((res) => {
                return resolve(res.data)
            })
            .catch((err) => {
                return reject(err)
            })
    })
}

/**
 * List
 * This endpoint does not require authentication
 * @param {*} email
 */
export const listObj = () => {
    return new Promise((resolve, reject) => {
        Axios.get(`/${ENDPOINT}`)
            .then((res) => {
                return resolve(res.data)
            })
            .catch((err) => {
                return reject(err)
            })
    })
}

/**
 * Put
 * @param {*} email
 */
export const putObj = (email) => {
    return new Promise((resolve, reject) => {
        Axios.put(`/${ENDPOINT}/${toBase64(email)}`)
            .then((res) => {
                return resolve(res.data)
            })
            .catch((err) => {
                return reject(err)
            })
    })
}



/**
 * Put list
 */
export const putList = (emailList) => {
    return new Promise((resolve, reject) => {
        Axios.put(`/${ENDPOINT}`, JSON.stringify(emailList))
            .then((res) => {
                return resolve(res.data)
            })
            .catch((err) => {
                return reject(err)
            })
    })
}


/**
 * Delete
 * @param {*} email
 */
export const deleteObj = (email) => {
    return new Promise((resolve, reject) => {
        Axios.delete(`/${ENDPOINT}/${toBase64(email)}`)
            .then((res) => {
                return resolve(res.data)
            })
            .catch((err) => {
                return reject(err)
            })
    })
}
